import { take, call, put, select } from "redux-saga/effects";
import { SearchActionTypes } from "../reducers/search/search-types";
import { ISearchRequest } from "../reducers/search/search-actions";
import { callServer, padRootUrl } from "~/api/call-server";
import { RequestType } from "~/api/response-types/types";
import { IRootState } from "../reducers";

function* search(searchParams: ISearchRequest) {
    try {
        const { searchParams: currentParams } = yield select((state: IRootState) => state.search);

        const data = {
            ...currentParams,
            ...searchParams
        };

        const response = yield call(callServer, padRootUrl(searchParams.apiUrl), RequestType.POST, data);

        yield put({
            type: SearchActionTypes.SEARCH_SUCCESS,
            payload: {
                ...response.payload,
                page: data.page
            }
        });

        yield put({
            type: SearchActionTypes.UPDATE_SEARCH_PARAMS,
            payload: data
        });
    } catch (error) {
        yield put({
            type: SearchActionTypes.SEARCH_ERROR
        });
    }
}

export default function* searchSaga() {
    while (true) {
        const action = yield take(SearchActionTypes.SEARCH_REQUEST);
        if (action.type === SearchActionTypes.SEARCH_REQUEST) {
            yield call(search, action.payload);
        }
    }
}
